import React, { useState, useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import MainRouter from './MainRouter';
import LoginForm from './LoginForm';
import { CheckAuth } from '../../api/AuthAPI';

import '../../css/style.css';
import '@fortawesome/fontawesome-free/css/all.css';

const NextApp = () => {
    const [loading, setLoading] = useState(false);
    const [authenticated, setAuthenticated] = useState(false);

    const history = useHistory();
    const location = useLocation();

    useEffect(() => {
        checkAuth();
    }, []);

    useEffect(() => {
        if (authenticated && location.pathname === '/') {
            history.push('/CancellationList');
        }
    }, [authenticated, location.pathname, history]);

    const checkAuth = () => {
        setLoading(true);

        CheckAuth()
            .then((result) => {
                setAuthenticated(true);
                setLoading(false);
            })
            .catch(() => {
                localStorage.setItem('fchpToken', null);
                sessionStorage.setItem('fchpToken', null);
                setAuthenticated(false);
                setLoading(false);

                if (location.pathname !== '/') {
                    history.push('/');
                }
            });
    };

    return (
        <div id="app-container">
            {loading ? null : authenticated ? (
                <MainRouter />
            ) : (
                <div className="">
                    <div className="">
                        <LoginForm checkAuth={checkAuth} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default NextApp;